import BaseModelAPI from '../BaseModelAPI';

export default class PartPriceList extends BaseModelAPI {

	static entity = 'partpricelist'
	static entityName = 'partprice';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
